import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=05b4756d&scoped=true"
import script from "./Taxes.vue?vue&type=script&lang=ts"
export * from "./Taxes.vue?vue&type=script&lang=ts"
import style0 from "./Taxes.vue?vue&type=style&index=0&id=05b4756d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4756d",
  null
  
)

export default component.exports